import { render, staticRenderFns } from "./FieldTypeSelect.vue?vue&type=template&id=490646e3"
import script from "./FieldTypeSelect.vue?vue&type=script&lang=js"
export * from "./FieldTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports